import cx from "classnames";

// Components
import Search from "../Search/SearchContainer";

// CSS
import styles from "./side-menu.module.scss";

const SideMenu = (props) => {
    const {
        goToHomepage,
        goToConferences,
        goToVideos,
        isSideMenuActive,
        setIsSideMenuActive,
    } = props;

    return (
        <div
            className={cx(styles.container, {
                [styles["container--active"]]: isSideMenuActive,
            })}
        >
            <div className={styles.sideMenu}>
                <div className={styles.close}>
                    <span
                        className={cx(styles.icon, "material-icons")}
                        onClick={() => setIsSideMenuActive(false)}
                    >
                        close
                    </span>
                </div>
                <div className={styles.links}>
                    <span className={styles.link} onClick={goToHomepage}>
                        SYMPHONY INNOVATE
                    </span>

                    <span className={styles.link} onClick={goToConferences}>
                        CONFERENCES
                    </span>

                    <span className={styles.link} onClick={goToVideos}>
                        VIDEOS
                    </span>

                    <a
                        className={styles.link}
                        href="https://symphony.com/company/about/"
                        rel="noreferrer noopener"
                        target="_blank"
                    >
                        ABOUT SYMPHONY
                    </a>
                </div>
                <Search classes={styles.search} isLight={true} />
            </div>
        </div>
    );
};

export default SideMenu;
